module.exports = __webpack_public_path__ + "static/media/show-feedback-message.36e1eb10.svg";